import {getTodayStartTime} from 'shared/utils/dateTime';
import {MS_IN_DAY} from 'shared/const';

export function createBudget(initial: MoneyAmount, daysCount: DaysCount): Budget {
  const startDate: DayStartTimeStamp = getTodayStartTime();
  const finishDate: DayStartTimeStamp = startDate + daysCount * MS_IN_DAY;

  return {
    initial,
    spent: 0,
    added: 0,

    startDate,
    finishDate,
  };
}
